import Vue from 'vue'
import VueRouter from 'vue-router'
import Calender from '../views/Calendar.vue'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import ListData from '../views/ListData'
import HomeNewPartner from '../views/HomeNewPartner'
import CheckInOut from '../views/CheckInOut'
import VisitDetail from '../views/VisitDetail'
import VisitViews from '../views/VisitViews.vue'
import VisitPlanDate from '../views/VisitPlanDate.vue'
import Stock from '../views/Stock.vue'
import TodoList from '../views/TodoList.vue'
import TodoListForm from '../views/TodoListForm.vue'
import CollectTargetPrice from '../views/CollectTargetPrice.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/calendar',
    name: 'Calendar',
    component: Calender,
    meta: { requireAuth: true },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requireAuth: true },
  },
  {
    path: '/home',
    name: 'HomeNewPartner',
    component: HomeNewPartner,
    meta: { requireAuth: true },
  },
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/listdata',
    name: 'ListData',
    component: ListData,
    meta: { requireAuth: true },
  },
  {
    path: '/checkinout',
    name: 'CheckInOut',
    component: CheckInOut,
    meta: { requireAuth: true },
  },
  {
    path: '/visitdetail/:customerID/:visitID',
    name: 'VisitDetail',
    component: VisitDetail,
    meta: { requireAuth: true },
  },
  {
    path: '/visitviews/:customerID/:visitID',
    name: 'VisitViews',
    component: VisitViews,
    meta: { requireAuth: true },
  },
  {
    path: '/visitplandate/:customerID',
    name: 'VisitPlanDate',
    component: VisitPlanDate,
    meta: { requireAuth: true },
  },
  {
    path: '/stock',
    name: 'Stock',
    component: Stock,
    meta: { requireAuth: true },
  },
  {
    path: '/todo-list',
    name: 'TodoList',
    component: TodoList,
    meta: { requireAuth: true },
  },
  {
    path: '/todo-list-form',
    name: 'TodoListForm',
    component: TodoListForm,
    meta: { requireAuth: true },
  },
  {
    path: '/collect-target-price',
    name: 'CollectTargetPrice',
    component: CollectTargetPrice,
    meta: { requireAuth: true },
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export default router
